import React from 'react';

import { Box, Heading, TextButton } from 'wix-style-react';
import * as css from './SectionTitle.scss';

export interface SectionTitleProps {
  dataHook: string;
  title: string;
  actionTitle?: string;
  actionOnClick?(): void;
}
export const SectionTitle: React.FC<SectionTitleProps> = (props) => {
  const { dataHook, title, actionOnClick, actionTitle } = props;

  return (
    <React.Fragment>
      <Box
        marginBottom="24px"
        paddingBottom="20px"
        paddingTop="40px"
        borderBottom="1px solid #dfe5eb"
        align="space-between"
      >
        <Heading dataHook={dataHook} appearance="H2">
          {title}
        </Heading>
        {actionTitle && (
          <TextButton
            className={css.action}
            dataHook={`${dataHook}-action`}
            onClick={actionOnClick}
          >
            {actionTitle}
          </TextButton>
        )}
      </Box>
    </React.Fragment>
  );
};
